import * as React from "react";
export default function TheMethodology() {
  return <section data-section-id="108430" id="ai-educational-core" className="bg-[#e0f2f2] text-[#222222] py-24 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-16 gap-y-12">
          {}
          <div className="lg:col-span-4">
            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight uppercase text-[#ea0f0f]">
              About Our Core
            </h2>
          </div>

          {}
          <div className="lg:col-span-8 flex flex-col gap-8 text-lg sm:text-xl leading-relaxed text-[#222222]">
            <p>
              Our passion lies in crafting insightful and engaging content that
              helps you explore and better understand the world of artificial
              intelligence. We approach digital education as a systemic journey,
              aligning{" "}
              <strong className="font-semibold text-[#ea0f0f]">
                Technical Insight
              </strong>
              , ethical inquiry, and future-forward perspectives into a cohesive
              learning experience.
            </p>
            <p>
              The foundation of our resources rests on the clarity of{" "}
              <strong className="font-semibold text-[#ea0f0f]">
                AI Basics
              </strong>{" "}
              and the depth of{" "}
              <strong className="font-semibold text-[#ea0f0f]">
                Advanced Research
              </strong>
              . Most of our technical guides are presented in a convenient
              'drop-down' format.{" "}
              <span className="italic opacity-90">
                Note: If the font size appears small on your display, you can
                easily increase it using Control and + for better legibility.
              </span>
            </p>
            <p>
              Ultimately, our objective is to prepare you for the era of{" "}
              <strong className="font-semibold text-[#ea0f0f]">
                Asymmetric Intelligence
              </strong>
              . This website is intended for readers with a strong interest in
              AI; while we use occasional humor, we tackle vast, complex topics
              to ensure you maintain a defensible edge in an automated world.
            </p>
          </div>
        </div>
      </div>
    </section>;
}